"use client";

import { useMemo, useRef, useEffect } from "react";
import { Table, Tag, Card, Button, Checkbox, Spin } from "antd";
import { EditOutlined } from "@ant-design/icons";

const StockTable = ({
  data,
  loading,
  loadingMore,
  hasMore,
  onLoadMore,
  selectedItemType,
  selectedCategory,
  selectedLocation,
  searchQuery,
  onRowClick
}) => {
  const filteredData = useMemo(() => {
    let filtered = data;

    // if (selectedLocation !== "all") {
    //   filtered = filtered.filter((item) =>
    //     item.location.toLowerCase().includes(selectedLocation.toLowerCase())
    //   );
    // }

    // if (selectedItemType !== "all") {
    //   filtered = filtered.filter((item) => item.itemType === selectedItemType);
    // }

    // if (selectedCategory !== "all" && selectedCategory !== "Low Stock") {
    //   filtered = filtered.filter((item) => item.category === selectedCategory);
    // }

    // if (searchQuery) {
    //   filtered = filtered.filter(
    //     (item) =>
    //       item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //       item.sku.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //       item.brand.toLowerCase().includes(searchQuery.toLowerCase())
    //   );
    // }

    // if (selectedCategory === "Low Stock") {
    //   filtered = filtered.filter(
    //     (item) =>
    //       item.stockStatus === "low" ||
    //       item.stockStatus === "critical" ||
    //       item.count < item.reorderLevel
    //   );
    // }

    return filtered;
  }, [data, selectedLocation, selectedItemType, selectedCategory, searchQuery]);

  // Scroll event handler for lazy loading
  const tableBodyRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const target = e.target;
      if (!target) return;

      const { scrollTop, scrollHeight, clientHeight } = target;
      const scrolledToBottom = scrollHeight - scrollTop - clientHeight < 200;

      if (scrolledToBottom && hasMore && !loadingMore) {
        onLoadMore();
      }
    };

    // Find the table body element after render
    const tableBody = document.querySelector('.ant-table-body');
    if (tableBody) {
      tableBodyRef.current = tableBody;
      tableBody.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (tableBodyRef.current) {
        tableBodyRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, [hasMore, loadingMore, onLoadMore]);

  const statusTag = (status, count) => {
    if (count < 0 || status === "critical")
      return <Tag color="red">Critical</Tag>;
    if (status === "low") return <Tag color="orange">Low Stock</Tag>;
    return <Tag color="green">Healthy</Tag>;
  };

  const columns = [
    {
      title: <Checkbox />,
      dataIndex: "select",
      render: () => <Checkbox />,
      width: 50,
    },
    {
      title: "SKU",
      dataIndex: "value",
      width: 100,
      render: (v) => <span style={{ fontFamily: "monospace" }}>{v}</span>,
    },
    {
      title: "Item Name",
      dataIndex: "product",
      width: 200,
    },
    {
      title: "Category",
      dataIndex: "category",
      width: 80,
    },
    {
      title: "Item Type",
      dataIndex: "item_type",
      width: 70,
    },
    {
      title: "Brand",
      dataIndex: "brand",
      width: 70,
    },
    {
      title: "Count",
      dataIndex: "qtyonhand",
      align: "right",
      width: 70,
      render: (v, item) => (
        <>
          <b>
            {v} {item.unit}
          </b>
          {item.reorderLevel && (
            <div style={{ fontSize: 12, color: "#888" }}>
              Min: {item.reorderLevel}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Last Updated",
      dataIndex: "last_updated",
      width: 150,
    },
  ];

  // Show message when no location is selected
  if (selectedLocation === "all") {
    return (
      <div>
        <Card
          style={{
            borderRadius: 12, marginTop: "10px",
            textAlign: "center",
            padding: "40px 20px"
          }}
        >
          <div style={{ fontSize: 16, color: "#999" }}>
            <p style={{ fontSize: 18, fontWeight: 500, marginBottom: 8 }}>Please Select a Location</p>
            <p style={{ marginBottom: 0 }}>Choose a location from the dropdown above to view stock data.</p>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div >
      <Card
        // title={

        // }
        style={{
          borderRadius: 12, marginTop: ""
        }}
      >
        <div style={{ fontSize: 20, fontWeight: 600, padding: "5px 1px 10px 1px" }}>
          {selectedCategory === "Low Stock"
            ? "Low Stock Items"
            : selectedCategory !== "all"
              ? selectedCategory
              : selectedItemType !== "all"
                ? `${selectedItemType} Items`
                : "Stock Items"}{" "}
          <span style={{ color: "#666", fontWeight: 400 }}>
            ({filteredData.length} items)
          </span>
        </div>
        <Table
          size="small"
          dataSource={filteredData}
          columns={columns}
          rowKey="id"
          pagination={false}
          loading={loading}
          onRow={(record) => ({
            onClick: () => {
              if (onRowClick) onRowClick(record);
            },
            style: { cursor: 'pointer' }
          })}
          scroll={{
            y: "44vh",      // vertical scrolling
            x: "max-content" // expand width based on content
          }}
          footer={() =>
            loadingMore ? (
              <div style={{ textAlign: 'center', padding: '10px' }}>
                <Spin size="small" /> <span style={{ marginLeft: 8 }}>Loading more...</span>
              </div>
            ) : !hasMore && filteredData.length > 0 ? (
              <div style={{ textAlign: 'center', padding: '10px', color: '#999' }}>
                No more items to load
              </div>
            ) : null
          }
        />
      </Card>
    </div>
  );
}
export default StockTable